/** When your routing table is too long, you can split it into small modules **/
import Layout from '../../layout'

export default [
  {
    path: '/statistics/course-log',
    name: 'statistics_course_log',
    component: () => import('../../view/statistics/teacher-course/index'),
    meta: {
      title: '备课&授课',
      icon: 'fe-book-open',
      affix: true,
      roles: [
        'statistics-course_log-view'
      ]
    },
  },
  {
    path: '/statistics/course-ware',
    name: 'statistics_courseware_log',
    component: () => import('../../view/statistics/teacher-courseware/index'),
    meta: {
      title: '培训课程&课件',
      icon: 'fe-book-open',
      affix: true,
      roles: [
        'statistics-course_log-view'
      ]
    },
  },
  {
    path: '/statistics/course-authorize',
    name: 'statistics_course_authorize',
    component: () => import('../../view/statistics/teacher-course/authorize'),
    meta: {
      title: '授权统计',
      icon: 'fe-check-square',
      affix: true,
      roles: [
        'statistics-course_authorize-view'
      ]
    },
  },
  {
    path: '/statistics/course',
    name: 'statistics_course',
    component: () => import('../../view/statistics/course/index'),
    meta: {
      title: '课程统计',
      icon: 'dripicons-document-remove',
      affix: true,
      roles: [
        'statistics-course-view'
      ]
    },
  },
  {
    path: '/statistics/teacher',
    name: 'statistics_teacher',
    component: () => import('../../view/statistics/teacher/index'),
    meta: {
      title: '教师统计',
      icon: 'fe-users',
      affix: true,
      roles: [
        'statistics-teacher-view'
      ]
    },
  }
]
